import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 1680,
	height: 200,
	fill: "none",
	viewBox: "0 0 1680 200",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M-16.97 200H1711V78.2a29.09 29.09 0 0 0-27.95-29.18c-93.29-3.6-399.58-14.76-603.05-14.91-215.18-.16-302.74 8.57-526.96 0-87.4-3.35-102.38-5.7-162.6-13.94C312.48 9.5 188.92 7.83 188.92 7.83L124.56 4.9s-35.4-8.64-64.37-2.95C30.26 7.84.05 7.84-10.49 34.11c-7.3 18.22-6.48 57.44-6.48 71.74V200Z"
	})
});
const SvgSnow = styled(base)({});
export default SvgSnow;
